// extracted by mini-css-extract-plugin
module.exports = {"blogList":"styles_blogList__YPFWl"};